import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonModal,
  IonPage,
  IonPopover,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { blogPosts } from "../../blog/blogData";
import { Post } from "./Post";
import "./Landing.css";
import { useEffect, useRef, useState } from "react";
import { closeOutline, menuOutline, schoolOutline } from "ionicons/icons";
import { Capacitor } from "@capacitor/core";

import Footer from "./Footer";
import { useTranslation } from "react-i18next";

export const LandingHeader = () => {
  const { i18n, t } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);
  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "fr" : "en";
    i18n.changeLanguage(newLang);
  };

  return (
    <>
      <IonHeader transclucent={true}>
        <IonToolbar className="ion-toolbar">
          <IonButtons slot="end" className="menu-button-mobile">
            <IonButton onClick={() => setShowMenu(true)}>
              <IonIcon slot="icon-only" icon={menuOutline} />
            </IonButton>
          </IonButtons>
          {/* <IonTitle style={{ paddingLeft: "10px" }} className="poetsen"> */}
          {/* <div style={{ alignItems: "center" }}>
              <img
                src="/logo5.png"
                alt="LoonLog Logo"
                style={{
                  height: "60px",
                }} // Adjust height and margin as needed
              />
            </div> */}
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
              padding: "3px 8px 4px",
              fontSize: "20px",
            }}
            className="poetsen"
          >
            <img
              src="/logo4.png"
              alt="LoonLog Logo"
              style={{
                height: "40px",
                paddingLeft: "12px",
              }} // Adjust height and margin as needed
            />
            LoonLog
          </div>
          {/* </IonTitle> */}
          <IonButtons slot="end" className="desktop-links">
            <IonButton routerLink="/about" className="desktop-link">
              {t("landingHeader.about")}
            </IonButton>
            <IonButton routerLink="/terms-of-service" className="desktop-link">
              {t("landingHeader.terms")}
            </IonButton>
            <IonButton routerLink="/privacy-policy" className="desktop-link">
              {t("landingHeader.privacy")}
            </IonButton>
            <IonButton
              routerLink="/child-safety-policy"
              className="desktop-link"
            >
              {t("landingHeader.safety")}
            </IonButton>
            <IonButton routerLink="/contact-us" className="desktop-link">
              {t("landingHeader.help")}
            </IonButton>
            <IonButton routerLink="/faq" className="desktop-link">
              {t("landingHeader.faq")}
            </IonButton>
            <IonButton routerLink="/blog" className="desktop-link">
              {t("landingHeader.blog")}
            </IonButton>
            <IonButton className="desktop-link" onClick={toggleLanguage}>
              🌐 {i18n.language === "en" ? "FR" : "EN"}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      {/* The Vertical Mobile List (Standalone) */}
      {/* Full Screen Menu Modal */}
      <IonModal
        isOpen={showMenu}
        onDidDismiss={() => setShowMenu(false)}
        className="full-screen-menu"
      >
        <IonHeader className="ion-no-border">
          <IonToolbar style={{ "--background": "#1e1e1e" }}>
            <IonTitle
              style={{ padding: "10px", paddingLeft: "30px" }}
              className="poetsen"
            >
              <div style={{ alignItems: "center" }}>
                <img
                  src="/logo.png"
                  alt="LoonLog Logo"
                  style={{
                    height: "40px",
                  }} // Adjust height and margin as needed
                />
              </div>
            </IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setShowMenu(false)}>
                <IonIcon
                  slot="icon-only"
                  icon={closeOutline}
                  style={{ color: "white" }}
                />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent style={{ "--background": "#1e1e1e" }}>
          <IonList className="ion-list-item">
            <IonItem
              className="ion-list-item"
              button
              routerLink="/about"
              onClick={() => setShowMenu(false)}
            >
              <IonLabel>{t("landingHeader.about")}</IonLabel>
            </IonItem>
            <IonItem
              button
              routerLink="/terms-of-service"
              onClick={() => setShowMenu(false)}
            >
              <IonLabel>{t("landingHeader.terms")}</IonLabel>
            </IonItem>
            <IonItem
              className="ion-list-item"
              button
              routerLink="/privacy-policy"
              onClick={() => setShowMenu(false)}
            >
              <IonLabel>{t("landingHeader.privacy")}</IonLabel>
            </IonItem>
            <IonItem
              className="ion-list-item"
              button
              routerLink="/child-safety-policy"
              onClick={() => setShowMenu(false)}
            >
              <IonLabel>{t("landingHeader.safety")}</IonLabel>
            </IonItem>
            <IonItem
              className="ion-list-item"
              button
              routerLink="/contact-us"
              onClick={() => setShowMenu(false)}
            >
              <IonLabel>{t("landingHeader.help")}</IonLabel>
            </IonItem>
            <IonItem
              className="ion-list-item"
              button
              routerLink="/faq"
              onClick={() => setShowMenu(false)}
            >
              <IonLabel>{t("landingHeader.faq")}</IonLabel>
            </IonItem>
            <IonItem
              button
              className="ion-list-item"
              routerLink="/blog"
              onClick={() => setShowMenu(false)}
            >
              <IonLabel>{t("landingHeader.blog")}</IonLabel>
            </IonItem>
            <IonItem
              className="ion-list-item"
              button
              lines="none" // This removes the bottom border
              onClick={toggleLanguage}
            >
              <IonLabel>🌐 {i18n.language === "en" ? "FR" : "EN"}</IonLabel>
            </IonItem>
          </IonList>
        </IonContent>
      </IonModal>
    </>
  );
};

const Landing = () => {
  const { t } = useTranslation();
  const [showDownloadLinks, setShowDownloadLinks] = useState(true);
  useEffect(() => {
    const checkEnvironment = () => {
      const isNative = Capacitor.isNativePlatform();
      const isStandaloneMode =
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true;
      const isTWA = document.referrer.includes("android-app://");
      const isAndroidWebView = navigator.userAgent.toLowerCase().includes("wv");

      // If any of these are true, the user is ALREADY in the app
      if (isNative || isStandaloneMode || isTWA || isAndroidWebView) {
        setShowDownloadLinks(false);
      }
    };

    checkEnvironment();
  }, []);
  return (
    <IonPage className="Landng-page">
      <LandingHeader />
      <IonContent fullscreen className="landing-content">
        {/* HERO */}
        <section className="hero">
          <div className="hero-image-container">
            <img
              src="/loonlog-hero1.webp"
              // src="/landing-page-banner.svg"
              alt="LoonLog illustration representing a Canada-first community network"
              className="hero-image hide-on-mobile"
              loading="eager"
              fetchpriority="high"
            />
            <img
              // src="/LoonLog-hero-m.webp"
              src="/LoonLog-hero-m-4.webp"
              alt="LoonLog illustration representing a Canada-first community network"
              className="hero-image hide-on-desktop"
              loading="eager"
              fetchpriority="high"
            />
            {/* This extra div acts as the blender */}
            {/* <div className="hero-blender"></div> */}

            <div class="seo-text">
              <h1>Canada’s Community Network</h1>
              <h2>More Than Social Media</h2>
              <p>Connect with real people, real communities across Canada.</p>
              <p>Free to join. Built proudly in Canada.</p>
            </div>
            <div className="hero-actions">
              <IonButton
                routerLink="/signup"
                shape="round"
                // color="danger"
                className="register-btn"
              >
                {t("landing.register")}
              </IonButton>

              <IonButton
                routerLink="/login"
                shape="round"
                color="light"
                className="secondary-btn"
              >
                {t("landing.signin")}
              </IonButton>
            </div>
          </div>

          {showDownloadLinks && (
            <section id="download">
              <div>
                <p
                  style={{
                    textAlign: "center",
                  }}
                  className="download-text"
                >
                  {t("landing.downloadApp")}
                </p>
              </div>

              <div className="download">
                {/* Show Play Store only to Android/Desktop users */}
                <a href="https://play.google.com/store/apps/details?id=ca.loonlog.twa">
                  <img
                    alt="download loonlog app on play store"
                    // height={100}
                    src="/download/Get-It-On-GooglePlay_Badge_Web_color_English.svg"
                  />
                </a>

                {/* Show App Store only to iOS/Desktop users */}
                <a href="https://apps.apple.com/app/6747667709">
                  <img
                    alt="download loonlog app on app store"
                    // height={100}
                    src="/download/Download_on_the_App_Store_Badge_US-UK.svg"
                  />
                </a>
              </div>
            </section>
          )}
          <div className="hero-text">
            {/* <h1>
              {t("landing.headlineLine1")}
              <br />
            </h1>

            <p>{t("landing.description")}</p> */}

            {/* <span className="sub-note">{t("landing.subnote")}</span> */}
          </div>
          <p className="hero-tagline">
            {t("landing.heroTagline.main")}
            <br />
            <b>
              {t("landing.headlineLine2Before")}{" "}
              <span className="branding-color">
                {t("landing.headlineBrand")}
              </span>
              , {t("landing.headlineLine2After")}
            </b>
          </p>
          <div className="hero-text2">
            {/*
             <h2>{t("landing.heroText2Title")}</h2> */}
            <p>{t("landing.heroText2Desc")}</p>
          </div>
        </section>
        <section className="loonlog-hero">
          <div className="loonlog-hero-card">
            <div className="loonlog-hero-head-wrapper">
              <span className="loonlog-hero-icon">🎓 </span>
              <div>
                <h2 className="loonlog-hero-head card-main-title">
                  {t("landing.cards.card1.title")}
                </h2>
                <h3 className="branding-color subtitle">
                  {t("landing.cards.card1.subtitle")}
                </h3>
              </div>
            </div>
            <p className="loonlog-hero-description">
              {t("landing.cards.card1.desc")}
            </p>
          </div>
          <div className="loonlog-hero-card">
            <div className="loonlog-hero-head-wrapper">
              <span className="loonlog-hero-icon">🍁 </span>
              <div>
                <h2 className="loonlog-hero-head card-main-title">
                  {t("landing.cards.card2.title")}
                </h2>
                <h3 className="branding-color subtitle">
                  {t("landing.cards.card2.subtitle")}
                </h3>
              </div>
            </div>
            <p className="loonlog-hero-description">
              {t("landing.cards.card2.desc")}
            </p>
          </div>
          <div className="loonlog-hero-card">
            <div className="loonlog-hero-head-wrapper">
              <span className="loonlog-hero-icon">🤝 </span>
              <div>
                <h2 className="loonlog-hero-head card-main-title">
                  {t("landing.cards.card3.title")}
                </h2>
                <h3 className="branding-color subtitle">
                  {t("landing.cards.card3.subtitle")}
                </h3>
              </div>
            </div>
            <p className="loonlog-hero-description">
              {t("landing.cards.card3.desc")}
            </p>
          </div>
          {/* <div className="loonlog-hero-card">
            <div className="loonlog-hero-head-wrapper">
              <span
                className="loonlog-hero-icon"
                style={{ transform: "translateY(-10px)" }}
              >
                🚗
              </span>
              <div>
                <h2 className="loonlog-hero-head card-main-title">
                  {t("landing.cards.card4.title")}
                </h2>
                <h3 className="branding-color subtitle">
                  {t("landing.cards.card4.subtitle")}
                </h3>
              </div>
            </div>
            <p className="loonlog-hero-description">
              {t("landing.cards.card4.desc")}
            </p>
          </div> */}
          {/* <div className="loonlog-hero-card">
            <div className="loonlog-hero-head-wrapper">
              <span className="loonlog-hero-icon">🛡️ </span>
              <div>
                <h2 className="loonlog-hero-head card-main-title">
                  {t("landing.cards.card5.title")}
                </h2>
                <h3 className="branding-color subtitle">
                  {t("landing.cards.card5.subtitle")}
                </h3>
              </div>
            </div>
            <p className="loonlog-hero-description">
              {t("landing.cards.card5.desc")}
            </p>
          </div> */}
        </section>
        {/* ONLY SHOW IF NOT INSTALLED */}

        {/* VALUE STRIP */}
        <section className="value-strip">
          <IonGrid>
            <IonRow>
              <IonCol size="12" sizeMd="3" className="value-item">
                🇨🇦 <strong>{t("landing.canadianTitle")}</strong>
                <span>{t("landing.canadianDesc")}</span>
              </IonCol>

              {/* <IonCol size="12" sizeMd="3" className="value-item">
                👥 <strong>{t("landing.learnTitle")}</strong>
                <span>{t("landing.learnDesc")}</span>
              </IonCol> */}
              <IonCol size="12" sizeMd="3" className="value-item">
                🚗 <strong> {t("landing.cards.card4.title")}</strong>
                <span> {t("landing.cards.card4.subtitle")}</span>
              </IonCol>

              <IonCol size="12" sizeMd="3" className="value-item">
                🔒 <strong>{t("landing.privacyTitle")}</strong>
                <span>{t("landing.privacyDesc")}</span>
              </IonCol>
            </IonRow>
          </IonGrid>
        </section>

        <IonGrid>
          <IonRow
            style={{
              display: "flex",
              flexWrap: "wrap",
              maxWidth: "1300px",
              margin: "0 auto",
            }}
          >
            {blogPosts.map((post) => (
              <IonCol
                size="12"
                size-md="6"
                key={post.id}
                style={{ display: "flex", borderRadius: "23px" }}
              >
                <Post post={post} />
              </IonCol>
            ))}
          </IonRow>
        </IonGrid>
        <section className="hero-footer">
          <img src="/footer.webp" alt="footer" />
        </section>
        {/* FINAL CTA */}
        <section className="final-cta">
          <h2>{t("landing.finalcta")}</h2>
          <div className="final-cta-buttons">
            <IonButton
              routerLink="/signup"
              shape="round"
              // color="danger"
              className="register-btn"
            >
              {t("landing.register")}
            </IonButton>

            <IonButton
              routerLink="/login"
              shape="round"
              color="light"
              className="secondary-btn"
            >
              {t("landing.signin")}
            </IonButton>
          </div>
        </section>
        <Footer />
      </IonContent>
    </IonPage>
  );
};

export default Landing;
